
//Valentine's Offer text direct static replacement

(function () {
  var OLD_TEXTS = [
    "🥳 Vår jubileumsrea är live nu! 🥳",
    "🥳 Jubileumsrean är igång! 🥳"
  ];
 // var NEW_TEXT = "❤️ Vår valentinsrea är live nu! ❤️";
//  var NEW_TEXT = "Vår påsk-rea är nu igång 🐰🐣";
// var NEW_TEXT = "🕵️ Vår mystiska majrea är nu live! 🕵️";
// var NEW_TEXT = "🤸🎈 Vår Play Days-rea är nu igång! 🎈👩🏼‍🤝‍👨🏽";
  var NEW_TEXT = "🎒✨ Smart Start-rean är igång nu ✨📚";

  function replaceText(root) {
    var scope = root || document;

    scope
      .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
      .forEach(function (el) {
        if (OLD_TEXTS.includes(el.textContent.trim())) {
          el.textContent = NEW_TEXT;
        }
      });
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();




// (function() {

//   var NEW_HEADING_TEXT = "🥳 Vår jubileumsrea är igång nu! 🥳";
// var NEW_HEADING_HTML = '🥳 Vår <span class="black-friday-allproducts">jubileumsrea</span> är igång nu! 🥳';


//   // var NEW_HEADING_TEXT = "🎉 Vår Cyber Monday Rea är nu igång! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Vår <span class="black-friday-allproducts">Cyber Monday</span> Rea är nu igång! 🥳';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("jubileumsrean är igång") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("i dag") &&
//         lower.includes("jubileum") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/är det vårt\s+jubileum!?/i, "är vår jubileumsrea!");
//         newText = newText.replace(
//           /är vår jubileumsrea!/,
//           'är vår <span class="black-friday-allproducts">jubileumsrea!</span>'
//         );
//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();


// (function() {

//   var NEW_HEADING_TEXT = "🎄 Vår Julrea är nu igång! 🎅";
// var NEW_HEADING_HTML = '🎄 Vår <span class="black-friday-allproducts">Julrea</span> är nu igång! 🎅';


//   // var NEW_HEADING_TEXT = "🎉 Vår Cyber Monday Rea är nu igång! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Vår <span class="black-friday-allproducts">Cyber Monday</span> Rea är nu igång! 🥳';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("jubileumsrean är igång") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("i dag") &&
//         lower.includes("jubileum") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/är det vårt\s+jubileum!?/i, "är vår julrea!");
//         newText = newText.replace(
//           /är vår julrea!/,
//           'är vår <span class="black-friday-allproducts">julrea!</span>'
//         );
//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();
